<ng-template #btnContent>
  <!-- Left Icon -->
  @if (showLeftIcon && leftIconName; as icon) {
    <span class="button-icon left-icon" aria-hidden="true">
      <umss-icon
        [name]="icon"
        [size]="computedIconSize"
        [color]="iconColor"
      />
    </span>
  }

  <!-- Loading Spinner -->
  @if (loading) {
    <span class="loading-spinner" aria-hidden="true">
      <umss-icon name="phosphorCircleNotch" [size]="computedIconSize" />
    </span>
  }

  <!-- Label -->
  @if (showLabel) {
    <span class="button-label">{{ label }}</span>
  }

  <!-- Right Icon -->
  @if (showRightIcon && rightIconName; as icon) {
    <span class="button-icon right-icon" aria-hidden="true">
      <umss-icon
        [name]="icon"
        [size]="computedIconSize"
        [color]="iconColor"
      />
    </span>
  }
</ng-template>

@if (!isSlidable) {
  @if (href) {
    <a
      [href]="href"
      [target]="target"
      rel="noopener noreferrer"
      [class]="buttonClasses"
      [attr.data-size]="size"
      [attr.data-variant]="variant"
      [attr.aria-label]="iconOnly ? label : null"
      (click)="onButtonClick($event)"
    >
      <ng-container *ngTemplateOutlet="btnContent" />
    </a>
  } @else {
    <button
      [type]="type"
      [class]="buttonClasses"
      [attr.data-size]="size"
      [attr.data-variant]="variant"
      [disabled]="disabled || loading"
      [attr.aria-label]="iconOnly ? label : null"
      (click)="onButtonClick($event)"
    >
      <ng-container *ngTemplateOutlet="btnContent" />
    </button>
  }
} @else {
  <umss-slider-button
    [label]="label"
    [variant]="variant"
    [size]="size"
    [disabled]="disabled"
    [loading]="loading"
    [iconSize]="iconSize"
    [iconColor]="iconColor"
    [fullWidth]="fullWidth"
    [threshold]="0.9"
    (confirmed)="onSliderConfirmed()"
  />
}
